export const GET_EASY_FIDES_PROFILE = 'GET_EASY_FIDES_PROFILE'
export const GET_EASY_FIDES_PROFILE_SUCCESS = 'GET_EASY_FIDES_PROFILE_SUCCESS'
